import { Component, Inject, NgZone, OnInit, Renderer2 } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import KRGlue from "@lyracom/embedded-form-glue";


@Component({
  selector: 'app-payzen',
  templateUrl: './payzen.component.html',
  styleUrls: ['./payzen.component.css']
})


export class PayzenComponent implements OnInit {

  loader: boolean = true;
  innerHeight: number = window.innerHeight;
  payzen_data: any;
  promiseError = null;


  constructor(
    @Inject(MAT_DIALOG_DATA) data:any,
    public dialogRef: MatDialogRef<PayzenComponent>,
    private renderer: Renderer2,
    private Zone: NgZone
  ) {
    this.payzen_data = data.data;

    this.createPaytoken();
  }

  ngOnInit() {

    if (document.getElementById("csspayzen")) {

      document.getElementById("csspayzen")?.remove();
      document.getElementById("scriptpayzen")?.remove();
    }


    this.addJsToElement(this.payzen_data.pi_payzen.url + '/static/js/krypton-client/V4.0/ext/classic.js');
    document.head.innerHTML += '<link id="csspayzen" rel="stylesheet" href="' + this.payzen_data.pi_payzen.url + '/static/js/krypton-client/V4.0/ext/classic-reset.css">';

  }


  /**
  * @description insere le script dans index
  */
  addJsToElement(src: string): HTMLScriptElement {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    script.id = "scriptpayzen"
    this.renderer.appendChild(document.body, script);
    return script;
  }


  /**
   * @description creer le formulaire payzen et recupere le paiement
   */
  createPaytoken() {
   
    const endpoint:any = this.payzen_data.pi_payzen.url;
  
    const publicKey:any = this.payzen_data.pi_payzen.public_key;

    KRGlue.loadLibrary(endpoint, publicKey) /* Load the remote library */
      .then(({ KR }): any =>
        {
          return KR.setFormConfig({
            /* set the minimal configuration */
            formToken: this.payzen_data.pi_payzen.token,
            "kr-language": this.payzen_data.pi_payzen.country
          });
        }
      )
      .then(({ KR }) =>
        /* add a payment form  to myPaymentForm div*/
        KR.addForm("#myPaymentForm")
      )
      .then(({ KR, result }) => {

        KR.showForm(result.formId);
        this.loader = false;


        // KR.onError(function (event) {
          //   if (!event) {
        //     //onSubmit
        //     KR.onSubmit((event: any) => {
        //       KR.removeForms();
        //       this.closeDial(event)
        //     }
        //     )
        //   }

        // })


        KR.onSubmit((event: any) => {

          //error ou pas event envoye à la troisime fois

          //          event.clientAnswer.orderStatus =  "UNPAID" or "PAID"

          //           event.clientAnswer.transactions[0]
          //           detailedErrorCode: "51" or null
          //           detailedErrorMessage: "Insufficient funds or credit limit exceeded" or null
          //           detailedStatus: "REFUSED" or "AUTHORISED"
          //           errorCode: "ACQ_001" or null
          //           errorMessage: "payment refused" or null



          if (event.clientAnswer.orderStatus == "PAID") {
            KR.removeForms();
            this.closeDial(event)
          }

        })


      })
      .catch(
        (error:any) => (this.promiseError = error)
      );


  }


  closeDial(event?: any) {

    this.Zone.run(() => {
      event ? this.dialogRef.close({ paiement: event }) : this.dialogRef.close();
    });
  }


}





